import React from "react";

// Official DNA Automotive logo (transparent PNG on dark bg).
export default function Logo({ className = "", compact = false }) {
  return (
    <div className={`flex items-center ${className}`} data-testid="dna-logo">
      <img
        src="/dna-logo-v2.png"
        alt="DNA Automotive – Dein neues Auto"
        className={`w-auto object-contain ${compact ? "h-12 md:h-14 2xl:h-16" : "h-16 md:h-24"}`}
        draggable="false"
      />
    </div>
  );
}
